import { createContext } from "react";

export interface TokenInvitationState {
  tokens: string[];
  removeToken: (token: string) => void;
  clearTokens: () => void;
  respondToToken: (token: string, accept: boolean) => Promise<boolean>;
}

export const TokenInvitationContext =
  createContext<TokenInvitationState | null>(null);
